import * as ng from 'angular';

import { L10nService } from './l10n.service';

ng.module('e360')
   .directive('languagePicker', languagePickerDirective);

languagePickerDirective.$inject = ['l10n'];

const templateUrl = require('./language-picker.directive.html');

/**
 * Dropdown for switching language. Displays locale flags for each entry.
 */
export function languagePickerDirective(l10n:L10nService): ng.IDirective {
   return {
      restrict: 'E',
      templateUrl: templateUrl,
      scope: {
         language: '<',//current language
         languages: '<',//available languages
         title: '@',//the descriptor title above selected language. Defaults to 'Editing Copy:'
         callback: '&'
      },
      link: languagePickerDirectiveLinkFn
   };

   function languagePickerDirectiveLinkFn(scope, element, attrs) {
      //if a list of languages wasn't provided then use all languages
      scope.languages = scope.languages ? scope.languages : l10n.getLanguageCodes();
   }
}
